module.exports = __webpack_public_path__ + "static/media/background.143a3d6d.png";